const LOG_PREFIX = "[OCM][Custom] "
// You need this if instream runs as outstream's passback
const Aniview = require('../../services/aniview')

let customCode = (utils) => {
  return new Promise((resolve, reject) => {
    utils.contentLoaded().then(() => {
      
      outbrain_explore_more(document.querySelectorAll('body')[0])  
      outbrain_read_next(document.querySelectorAll('body')[0])  
      
      if (utils.getParameterByName('obs') == '1') {
      	utils.loadScript('https://thetamarketplace.com/serve/fosonlineinread', 'text/javascript', 1);
      } else {
      	let rand = Math.random()
        if (rand > 0.60) {
          utils.loadScript('https://thetamarketplace.com/serve/fosonlineinread', 'text/javascript', 1);
        } else {
          runOutstream(utils)
        }
      }
      
      
    })


    resolve(true)
  });
};

let runOutstream = (utils) => {
  (function(w, d) {
    try {
      d = w.top.document || d; w = w.top.document ? w.top : w;
    } catch (e) {}
    var ttag = function() {
      // Check v1 outstream service for excluded urls and append them in the array below
      const exclude_urls = [
        //  {'url': ''},
      ]

      for (let x = 0; x < exclude_urls.length; x++) {
        if (w.location.href.includes(exclude_urls[x].url)) {
          return
        }
      }

      // You need to find these 2 numbers (pm @Katerina, @peter, @Theo)
      w.teads.page(82839).placement(97380, {
        slider: {
          allow_corner_position: false, 
          allow_top_position: false
        }, 
        "css":"padding: 0px 0px 16px;", // The margin should reflect the styles of the articles paragraphs
        "format":"inread",
        "slot":{
          //"selector":"[itemprop=articleBody] > p", // The target to inject the teads video tag
          "selector":".article-text p",
          "minimum":2 // If the target is a multiple node result (e.g. .article > p), then supply the minimum (starts counting from 1, not 0)
        }
      }).passback(() => {
        // initMoxTv(document.querySelectorAll('[itemprop=articleBody] > p')[1], '_mwayss-17848d1cfd46cd08e2321e1ca7d04ea0', 'https://ad.mox.tv/mox/mwayss_invocation.min.js?pzoneid=5990&height=405&width=720&tld=fosonline.gr&ctype=div');
        //utils.loadScript('https://thetamarketplace.com/serve/fosonlineinread', 'text/javascript', 1);
        // Runs after instream service and only if no video ad came back
        //window.OCM.oipb = () => {
       //   utils.loadScript('https://thetamarketplace.com/serve/fosonlineinread', 'text/javascript', 1);	
//           ocmPassback(utils, document.querySelector('#inread-video'))
       // }

        // Enables the instream service, instantiates the class and runs it (you should have the service configured in its tab, but inactive)
        /*
        utils.config.services.instream.active = true
        const is = new Instream(utils, utils.config)
        is.run()*/
          utils.config.services.aniview.active = true
          const av = new Aniview(utils, utils.config)
          av.run()
        
      }).serve();
    };
    if (w.teads && w.teads.page) { ttag(); }
    else if (!w.teadsscript) {
      var s = document.createElement('script');
      var protocol = 'https:';
      s.src = protocol + '//s8t.teads.tv/media/format/v3/teads-format.min.js';
      s.async = true; s.onload = ttag; w.teadsscript = d.getElementsByTagName('head')[0].appendChild(s);
    } else {
      w.teadsscript.addEventListener('load', ttag);
    }
  })(window, document); 
}

function initMoxTv(selector, id, src) {
  (function (window, document) {
    if (!selector) {
      return;
    }

    var div = document.createElement('div');
    selector.parentNode.insertBefore(div, selector.nextSibling);
    div.setAttribute('data-id', id);

    var script_tag = document.createElement('script');
    script_tag.src = src;
    var container = document.querySelectorAll('[data-id=' + id + ']')[0];
    container.setAttribute('id', (container.getAttribute('data-id') + (new Date()).getTime()));
    container.removeAttribute('data-id');
    container.parentNode.insertBefore(script_tag, container);
  })(window, document);
}

let outbrain_explore_more = (slot) => {
  if (!slot) {
    return
  }

  //let widget = '<div class="OUTBRAIN" data-ob-contentUrl="' + window.location.href + '" data-widget-id="TR_1" style="margin:0 auto 60px" data-ob-installation-key="CYOCM2IDF6569I0FK92EEOL10"></div>'
  let widget = '<div class="OUTBRAIN" data-ob-contentUrl="' + window.location.href + '" data-widget-id="TR_1"  data-ob-installation-key="CYOCM2IDF6569I0FK92EEOL10"></div>'
  let script = document.createElement('script')
  script.async = 'async'
  script.src = 'https://widgets.outbrain.com/outbrain.js'
  slot.parentNode.insertBefore(script, slot)

  slot.insertAdjacentHTML('beforebegin', widget)
}

let outbrain_read_next = (slot) => {
  if (!slot) {
    return
  }

   let widget = '<div class="OUTBRAIN" data-ob-contentUrl="' + window.location.href + '" data-widget-id="READNXT_1"  data-ob-installation-key="CYOCM2IDF6569I0FK92EEOL10"></div>'
  let script = document.createElement('script')
  script.async = 'async'
  script.src = 'https://widgets.outbrain.com/outbrain.js'
  slot.parentNode.insertBefore(script, slot)

  slot.insertAdjacentHTML('beforebegin', widget)
}

module.exports = customCode;